import { LogOut } from "lucide-react";

function AdminHeader({ onLogout }) {
  return (
    <header className="rounded-2xl border border-midnight-navy/12 bg-white/92 px-6 py-5 shadow-soft md:px-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-royal-blue">Admin Panel</p>
          <h1 className="mt-2 text-2xl md:text-3xl">Testimonials Manager</h1>
          <p className="mt-2 text-sm text-slate-text/80">
            Add, edit, and manage public testimonials shown on the website.
          </p>
        </div>

        <button
          type="button"
          onClick={onLogout}
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-midnight-navy/20 bg-white px-4 py-2.5 text-sm font-semibold text-midnight-navy hover:border-royal-blue/35 hover:bg-royal-blue/5"
        >
          <LogOut className="h-4 w-4" aria-hidden="true" />
          Logout
        </button>
      </div>
    </header>
  );
}

export default AdminHeader;

